import React from 'react';
import { useHistory } from 'react-router-dom';

import './ServiceTile.css';
import scrollToTop from '../../utils/scrollToTop';

import activateOnKey from '../../utils/activateOnKey';

const ServiceTile = (service) => {
  const history = useHistory();

  const navigate = () => {
    history.push(`/${service.service.navigation}`);
    scrollToTop();
  };

  return (
    <div role="button" tabIndex={0} onKeyDown={activateOnKey} className="servicetile-container" onClick={navigate}>
      <div className="servicetile-image-container">
        <img
          rel="preload"
          loading="lazy"
          src={service.service.imageUrl}
          alt={service.service.altTag}
        />
      </div>

      <div className="servicetile-glass">
        <div className="servicetile-header">
          {service.service.title}
        </div>
        <div className="servicetile-button">
          Learn More
        </div>
      </div>
    </div>
  );
};
export default ServiceTile;
